import fetchival from '@exodus/fetch/experimental/fetchival'
import assert from 'minimalistic-assert'
import ms from 'ms'

const DEFAULT_STAKING_URL = 'https://staking.a.exodus.io'
const HTTP_POST_TIMEOUT = ms('30s')

export const stakingProviderClientFactory = (
  { defaultStakingUrl = DEFAULT_STAKING_URL } = Object.create(null)
) => {
  assert(defaultStakingUrl, '"defaultStakingUrl" must be provided')

  let stakingUrl = new URL(defaultStakingUrl) // always should be an URL instance

  const assetValidators = {
    polygon: '0x3f4ce357b9d61d3b904492b8b5abc69c6c693720',
    ethereum: '0xd523794c879d9ec028960a231f866758e405be34',
  }

  const setStakingUrl = (newStakingUrl) => {
    stakingUrl = new URL(newStakingUrl || defaultStakingUrl)
  }

  const stakingRequest = async ({ asset, data }) => {
    return fetchival(stakingUrl, {
      timeout: HTTP_POST_TIMEOUT,
    })(asset)('stake').post(data)
  }

  const notifyActionFactory = ({ type }) => {
    assert(type, '"type" is required')
    return async ({ asset: assetName, txId, delegator, amount, error }) => {
      assert(assetName, '"asset" must be provided')
      assert(assetValidators[assetName], '"invalid" asset')
      assert(txId, '"txId" is required')
      assert(delegator, '"delegator" is required')
      assert(amount, '"amount" is required')

      const stakingData = {
        asset: assetName,
        data: {
          delegator,
          actions: [
            {
              type,
              validator: assetValidators[assetName],
              amount,
              txId,
            },
          ],
        },
      }
      return stakingRequest(stakingData)
    }
  }

  const notifyStaking = notifyActionFactory({
    type: 'start',
  })

  const notifyUnstaking = notifyActionFactory({
    type: 'stop',
  })

  return { setStakingUrl, notifyStaking, notifyUnstaking }
}
